jQuery(document).ready(function ($) {
	if ($('.hero-11__form').length) {
		$(document).ready(function () {
			setTimeout(function () {
				$('.hero-11__form').hide();

				setTimeout(function () {
					$('.hero-11__form').show();
					$('.three-body').hide();
				}, 100);

				let hsButton = $('#hs-form-iframe-0').contents().find('.hbspt-form form input[type="submit"]');
				let hsField = $('#hs-form-iframe-0').contents().find('.hbspt-form form .hs-form-field');
				let hsFieldButton = $('#hs-form-iframe-0').contents().find('.hbspt-form form .hs-submit .actions');
				let hsInput = $('#hs-form-iframe-0').contents().find('.hbspt-form form input');
				let hsInputSubmit = $('#hs-form-iframe-0')
					.contents()
					.find('.hs-submit input[type="submit"]')
					.css('color', 'white');
				let hsLabel = $('#hs-form-iframe-0').contents().find('.hbspt-form form .hs-form-field > label');
				let hslink = $('#hs-form-iframe-0')
					.contents()
					.find('.hbspt-form form .hubspot-link__container.sproket');
				let multiContainer = $('#hs-form-iframe-0').contents().find('.hbspt-form form .multi-container');
				let multiContainerSelects = $('#hs-form-iframe-0')
					.contents()
					.find('.hbspt-form form .hs-form-radio-display');
				let hsConsent = $('#hs-form-iframe-0')
					.contents()
					.find('.hbspt-form form .legal-consent-container .hs-richtext');
				let hsConsentCheck = $('#hs-form-iframe-0')
					.contents()
					.find('.hbspt-form form .hs-form-booleancheckbox-display');
				let hsActions = $('#hs-form-iframe-0').contents().find('.hbspt-form form .actions');

				hsActions.css('text-align', 'initial');
				hsField.css('margin', '0');
				hsField.css('margin-bottom', '8px');
				hsFieldButton.css('margin', '0');
				hsFieldButton.css('padding', '0');

				multiContainerSelects.css('display', 'flex');
				multiContainerSelects.css('align-items', 'center');
				multiContainerSelects.css('color', '#9A9A9A');

				hsConsentCheck.css('display', 'flex');
				hsConsentCheck.css('align-items', 'center');
				hsConsentCheck.css('color', '#9A9A9A');
				hsConsentCheck.css('font-size', '10px');

				multiContainer.css('display', 'flex');
				multiContainer.css('width', 'fit-content');
				multiContainer.css('gap', '20px');
				multiContainer.css('align-items', 'end');

				hsInput.css('border-radius', '4px');
				hsInput.css('height', '42px');
				hsInput.css('color', '#19234B');
				hsInputSubmit.css('color', 'white');
				hsLabel.css('color', '#9A9A9A');
				hsLabel.css('font-size', '12px');
				// button
				hsButton.css('background-color', '#19234B');
				hsButton.css('width', 'max-content');
				hsButton.css('padding', '8px 14px');
				hsButton.css('border', 'none');
				hsButton.css('border-radius', '30px');
				hsButton.val('Enviar fomulario');
				hsConsent.css('color', '#9A9A9A');
				hsConsent.css('font-size', '10px');
				hsConsent.css('line-height', '16px');

				hslink.css('display', 'none');
			}, 1000);
			setTimeout(function () {
				$('.hero-11__form').hide();

				setTimeout(function () {
					$('.hero-11__form').show();
					$('.three-body').hide();
				}, 100);

				let hsButton = $('#hs-form-iframe-1').contents().find('.hbspt-form form input[type="submit"]');
				let hsField = $('#hs-form-iframe-1').contents().find('.hbspt-form form .hs-form-field');
				let hsFieldButton = $('#hs-form-iframe-1').contents().find('.hbspt-form form .hs-submit .actions');
				let hsInput = $('#hs-form-iframe-1').contents().find('.hbspt-form form input');
				let hsInputSubmit = $('#hs-form-iframe-1').contents().find('.hbspt-form form input[type="submit"]');
				let hsLabel = $('#hs-form-iframe-1').contents().find('.hbspt-form form .hs-form-field > label');
				let hslink = $('#hs-form-iframe-1')
					.contents()
					.find('.hbspt-form form .hubspot-link__container.sproket');
				let multiContainer = $('#hs-form-iframe-1').contents().find('.hbspt-form form .multi-container');
				let multiContainerSelects = $('#hs-form-iframe-1')
					.contents()
					.find('.hbspt-form form .hs-form-radio-display');
				let hsConsent = $('#hs-form-iframe-1')
					.contents()
					.find('.hbspt-form form .legal-consent-container .hs-richtext');
				let hsConsentCheck = $('#hs-form-iframe-1')
					.contents()
					.find('.hbspt-form form .hs-form-booleancheckbox-display');
				let hsActions = $('#hs-form-iframe-1').contents().find('.hbspt-form form .actions');

				hsActions.css('text-align', 'initial');
				hsField.css('margin', '0');
				hsField.css('margin-bottom', '8px');
				hsFieldButton.css('margin', '0');
				hsFieldButton.css('padding', '0');

				multiContainerSelects.css('display', 'flex');
				multiContainerSelects.css('align-items', 'center');
				multiContainerSelects.css('color', '#9A9A9A');

				hsConsentCheck.css('display', 'flex');
				hsConsentCheck.css('align-items', 'center');
				hsConsentCheck.css('color', '#9A9A9A');
				hsConsentCheck.css('font-size', '10px');

				multiContainer.css('display', 'flex');
				multiContainer.css('width', 'fit-content');
				multiContainer.css('gap', '20px');
				multiContainer.css('align-items', 'end');

				hsInput.css('border-radius', '4px');
				hsInput.css('height', '42px');
				hsInput.css('color', '#19234B');
				hsInputSubmit.css('color', 'white');
				hsLabel.css('color', '#9A9A9A');
				hsLabel.css('font-size', '12px');
				// button
				hsButton.css('background-color', '#19234B');
				hsButton.css('width', 'max-content');
				hsButton.css('padding', '8px 14px');
				hsButton.css('border', 'none');
				hsButton.css('border-radius', '30px');
				hsButton.val('Enviar fomulario');
				hsConsent.css('color', '#9A9A9A');
				hsConsent.css('font-size', '10px');
				hsConsent.css('line-height', '16px');

				hslink.css('display', 'none');

				let $hsFormFooter = $('.hs-form-iframe')
					.contents()
					.find('#hsForm_bc20bc3a-fcb1-4381-9d21-a718cff9ea4a');
				$hsFormFooter.css({
					display: 'flex',
					'align-items': 'center',
					background: 'white',
					height: '48px',
					'border-radius': '100px'
				});
				// let $hsEmail = $('.hs-form-iframe').contents().find('.hs-input');
				// $hsEmail.css({
				//     'height': '32px',
				//     'border': 'none',
				//     'background': 'transparent'
				// });

				let $hsError = $('.hs-form-iframe')
					.contents()
					.find('#hsForm_bc20bc3a-fcb1-4381-9d21-a718cff9ea4a label');
				$hsError.css({
					display: 'none'
				});
				let $hsButton = $('.hs-form-iframe').contents().find('.actions');
				$hsButton.css({
					padding: '0',
					margin: '0'
				});
				let $hsButtonSub = $('.hs-form-iframe').contents().find('.actions input');
				$hsButtonSub.val('Enviar');
				$hsButtonSub.css({
					'margin-right': '10px',
					'text-transform': 'uppercase',
					background: '#3686F7'
				});
			}, 1000);
		});
	}
});
